import {Modal, Platform} from 'react-native';

/**
 * Every orientation a React Native `<Modal>` is allowed to present in.
 * @type {string[]}
 */
export const ALL_MODAL_ORIENTATIONS = [
    'portrait',
    'portrait-upside-down',
    'landscape',
    'landscape-left',
    'landscape-right',
];

/**
 * Makes every `<Modal>` on iOS rotate with the app instead of being forced to portrait.
 *
 * React Native's iOS modal host only allows `portrait` on iPhone-idiom devices
 * (RCTModalHostView `supportedOrientationsMask`: all orientations on iPad, portrait on
 * everything else) unless `supportedOrientations` is passed. The app has ~150 `<Modal>`
 * usages and none sets it, so on a landscape iPhone — and on a foldable iPhone's wide
 * inner screen, which is not an iPad — every dialog, sheet and picker would snap to
 * portrait. A class-level default fixes all of them at once; Android and web ignore the prop.
 *
 * Idempotent, never overrides a default someone already set, and never throws.
 *
 * @param {Function} [ModalComponent=Modal] RN Modal class (injectable for tests).
 * @param {string} [os=Platform.OS] Current platform (injectable for tests).
 * @returns {boolean} True when the default was installed by this call.
 */
export const installModalOrientationDefault = (ModalComponent = Modal, os = Platform.OS) => {
    if (os !== 'ios' || typeof ModalComponent !== 'function') {
        return false;
    }

    const current = ModalComponent.defaultProps || {};

    if (current.supportedOrientations) {
        return false;
    }

    ModalComponent.defaultProps = {...current, supportedOrientations: ALL_MODAL_ORIENTATIONS};

    return true;
};
